
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/better-chatgpt-ui-for-daily-productivity",
      function () {
        return require("private-next-pages/better-chatgpt-ui-for-daily-productivity.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/better-chatgpt-ui-for-daily-productivity"])
      });
    }
  